import {
   AppointmentPractitioner,
   PractitionerAbleToCompleteAppointmentQuery,
} from '@dreryk/egabinet-appointment-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { calendarTranslationKeys } from '../translations';

type CalendarPanelLoaderRenderProps = {
   practitioners: AppointmentPractitioner[];
};

type CalendarPanelLoaderProps = {
   readonly children: (renderProps: CalendarPanelLoaderRenderProps) => JSX.Element;
};

export const CalendarPanelLoader = (props: CalendarPanelLoaderProps): JSX.Element => {
   const {
      data: practitioners,
      loading: practitionersLoading,
      error: practitionersError,
   } = useCqrsSearch<AppointmentPractitioner>(() => new PractitionerAbleToCompleteAppointmentQuery());

   if (practitionersLoading) {
      return <LoaderSpinner />;
   }

   if (practitionersError) {
      return (
         <Message
            testId={'failedToFetchSpecialists'}
            label={calendarTranslationKeys.failedToFetchSpecialists}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      practitioners: practitioners,
   });
};
